// extracted by mini-css-extract-plugin
module.exports = {"statistics":"ListingStatistics_statistics__3reQn","subTitle":"ListingStatistics_subTitle__3xCkL"};